/* eslint-disable react/react-in-jsx-scope */
import { CurrencyRupee } from '@mui/icons-material'

export const CURRENCY_ICON = {
  rupee: <CurrencyRupee sx={ { fontSize: 15 } } />,
}

export const D = 1
